module.exports = __webpack_public_path__ + "img/snub-dodecahedron.7d785339.png";